export default {
      id: "cam-usage",
      viewBox: "0 0 420.8 420.8",
      url: "/assets/svg/" + "sprite.svg#cam-usage",
      toString: function () {
        return this.url;
      }
    }